import { Link, useLocation } from "react-router-dom";
import { Logo } from "../../assets/images";
import styles from "./Navbar.module.scss";

const Navbar: React.FC = () => {
  const location = useLocation();

  return (
    <div className={styles.navContainer}>
      <Link to="/">
        <div className={styles.logoWrapper}>
          <img className={styles.logo} src={Logo} alt="" />
        </div>
      </Link>
    </div>
  );
};

export default Navbar;
